export default __webpack_public_path__ + "luxe_logo.90dfd350.svg";